module.exports = __webpack_public_path__ + "static/scale-model-of-honor-women-today-online-magazine-in-tacoma-washington-d7b9f4d337b6ff85e75b4a7525711211.png";